const Expand = {
	name: 'Expand',
  template: `
		<div class="expand">
			<slot :isExpanded="isExpanded" :toggleExpand="toggleExpand"></slot>
		</div>
  `,
  data: function() {
    return {
      isExpanded: false,
    }
  },
  methods: {
    toggleExpand: function() {
		this.isExpanded = !this.isExpanded;
    }
  },
};

export default Expand;



// WEBPACK FOOTER //
// ../shared/components/expand/index.js